import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface OpeningBalanceFinanceState {
    data: any[] | null;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allOpeningBalanceFinanceList: any[];
}

const initialState: OpeningBalanceFinanceState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allOpeningBalanceFinanceList: [],
};

export const openingBalanceFinanceSlice = createSlice({
    name: "openingBalanceFinance",
    initialState,
    reducers: {
        setOpeningBalanceFinance: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPage;
            state.currentPage = action.payload.data.currentPage;
        },
        setOpeningBalanceFinanceBySearch: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPage;
            state.currentPage = action.payload.data.currentPage;
        },
        setAllOpeningBalanceFinance: (state, action) => {
            state.allOpeningBalanceFinanceList = action.payload.data;
        },
        resetOpeningBalanceFinance: () => initialState,
    },
});


export const {
    setOpeningBalanceFinance,
    setOpeningBalanceFinanceBySearch,
    setAllOpeningBalanceFinance,
    resetOpeningBalanceFinance,
} = openingBalanceFinanceSlice.actions;

export const getOpeningBalanceFinanceData = (state: RootState) =>
    state.openingBalanceFinance.data;
export const getOpeningBalanceFinanceList = (state: RootState) =>
    state.openingBalanceFinance.allOpeningBalanceFinanceList;
export const getOpeningBalanceFinanceTotalRecords = (state: RootState) =>
    state.openingBalanceFinance.totalRecords;
export const getOpeningBalanceFinanceBySearch = (state: RootState) =>
    state.openingBalanceFinance.data;

export default openingBalanceFinanceSlice.reducer;
